
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sharedBy/[userId]",
      function () {
        return require("private-next-pages/sharedBy/[userId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sharedBy/[userId]"])
      });
    }
  